import { publicEnv } from '~/features/environment/public';
import { queryUdacityService } from '~/utils/query-udacity-service';

import { Favorites, favoritesSchema } from '../models/favorite';

export async function getFavorites({ jwt, userId }: { jwt: string; userId: string }): Promise<Favorites> {
  return await queryUdacityService({
    url: `${publicEnv.NEXT_PUBLIC_RECOMMENDATIONS_URL}/favorites?userId=${userId}`,
    method: 'GET',
    zodSchema: favoritesSchema,
    authorization: `Bearer ${jwt}`,
  });
}
